import React, { Fragment, useRef, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import ReactToPrint from "react-to-print";

const useStyles = makeStyles(() => ({
  page: {
    padding: 5,
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  barcodeContainer: {
    display: "flex",
    flexDirection: "column",
  },
  barcodeText: {
    textAlign: "center",
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginLeft: 100,
  },
  subTitle: {
    marginTop: 20,
  },
  tableContainer: {
    marginTop: 10,
  },
  table: {
    fontFamily: "arial, sans-serif",
    borderCollapse: "collapse",
    width: "100%",
  },
  tableContent: {
    border: "1px solid #dddddd",
    textAlign: "left",
    padding: 8,
  },
  footerContainer: {
    display: "flex",
    float: "right",
    marginTop: 70,
  },
  image: {
    border: "none",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  pdfContainer: {
    width: "100%",
    height: "90vh",
    overflowY: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const BarcodePrintViewV2 = () => {
  const classes = useStyles();
  const componentRef = useRef();
  // eslint-disable-next-line no-unused-vars
  const [imageFile, setImageFile] = useState("");
  useEffect(() => {
    const data = localStorage.getItem("ckBarcodeData") || "{}";
    const jsonData = JSON.parse(data) || {};
    const fileName = jsonData["fileName"];
    if (fileName) {
      setImageFile(fileName);
      window.print();
      // document.getElementById("btnWorkorderPrint").click();
      setTimeout(function () {
        localStorage.removeItem("ckBarcodeData");
        window.close();
        if (!window.closed) {
          window.location = "#/sales-order";
        }
      }, 3000);
    } else {
      window.close();
      if (!window.closed) {
        window.location = "#/sales-order";
      }
    }
  }, []);

  return (
    <Fragment>
      <div ref={componentRef} className={classes.page}>
        <div className={classes.pdfContainer}>
          {/* <Worker workerUrl='https://unpkg.com/pdfjs-dist@2.8.335/legacy/build/pdf.worker.js'>
            <Viewer fileUrl={"https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"} plugins={newPlugin} />
          </Worker> */}
          {/* <Document file="https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf">
            <Page />
          </Document> */}
          {/* <PDFViewer
            document={{
                // url:  `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderItemsImagesSummaryDownload?orderId=${this.state.selectedOrder.orderId}&productId=${this.state.selectedSalesData.productId}`,
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
              }}
        /> */}
          {/* <img
            alt="Error getting barcode"
            width="600px"
            src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${imageFile}`}
          /> */}
        </div>
      </div>
      <ReactToPrint
        trigger={() => {
          return (
            <Button
              id="btnWorkorderPrint"
              style={{
                display: "none",
                float: "right",
                marginTop: 40,
                marginRight: 20,
                textTransform: "capitalize",
                opacity: 0.8,
                marginLeft: "94%",
              }}
              color="primary"
              variant="contained"
            >
              Print
            </Button>
          );
        }}
        content={() => componentRef.current}
        pageStyle="@page { size: A4}"
      />
    </Fragment>
  );
};

export default BarcodePrintViewV2;
